import formatNumbers from '../../../../helpers/formatNumbers';
import { assignPageNameAndFire } from "../../../../helpers/osTracking";
import Cookies from "js-cookie";

class ItemizedPriceComponent {
    constructor (itemizedPriceContainer, OS_MODAL, emitter) {
        this.OS_MODAL = OS_MODAL;
        this.itemizedPriceContainer = itemizedPriceContainer;
        this.emitter = emitter;
        this.finishedToggle = true;
        this.primaryCta = this.OS_MODAL.querySelector('.payment-details__primary-cta');
        this.msrp = this.OS_MODAL.querySelector('.itemized-titles.msrp');
        this.msrpParagraphText = this.msrp.querySelector('.msrp-paragraph-text');
        this.dealerDiscount = this.OS_MODAL.querySelector('.itemized-titles.dealer-discount');
        this.dealerDiscountParagraphText = this.dealerDiscount.querySelector('.dealer-discount-paragraph-text');
        this.dealerPrice = this.OS_MODAL.querySelector('.itemized-titles.dealer-price');
        this.dealerPriceLabel = this.dealerPrice.querySelector('.dealer-price-label');
        this.dealerPriceHeader = this.dealerPrice.querySelector('.dealer-price-header');
        this.rebates = this.OS_MODAL.querySelector('.itemized-titles.rebates');
        this.rebatesParagraphText = this.rebates.querySelector('.rebates-paragraph-text');
        this.downPayment = this.OS_MODAL.querySelector('.itemized-titles.down-payment');
        this.downPaymentParagraphText = this.downPayment.querySelector('.down-payment-paragraph-text');
        this.tradeInValue = this.OS_MODAL.querySelector('.itemized-titles.trade-in-value');
        this.tradeInValueParagraphText = this.tradeInValue.querySelector('.trade-in-value-paragraph-text');
        this.amountFinanced = this.OS_MODAL.querySelector('div.itemized-titles.amount-financed');
        this.salesTax = this.OS_MODAL.querySelector('.itemized-titles.sales-tax');
        this.salesTaxParagraphText = this.salesTax.querySelector('.sales-tax-paragraph-text');
        this.regFees = this.OS_MODAL.querySelector('.itemized-titles.reg-fees');
        this.regFeesParagraphText = this.regFees.querySelector('.reg-fees-paragraph-text');
        this.totalPurchasePrice = this.OS_MODAL.querySelector('.itemized-titles.purchase-price');
        this.purchasePriceHeader = this.totalPurchasePrice.querySelector('.purchase-price-header');
        this.cashDueAtSigning = this.itemizedPriceContainer.querySelector('.cash-due-at-signing');
        this.cashDueAtSigningParagraphText = this.cashDueAtSigning.querySelector('.cash-due-at-signing-paragraph-text');

        this._toggleItemized = this._toggleItemized.bind(this);

        this.emitter.on('header-component-rerendered', (vehicleData, selectedOption, OS_DATA) => {
            this.update(vehicleData, selectedOption, OS_DATA);
        });
    }

    update(vehicleData, selectedOption, OS_DATA) {
        this.itemizedPriceButtonContainer = this.OS_MODAL.querySelector('.itemized-price-button-container');
        this.itemizedPriceButton = this.OS_MODAL.querySelector('.itemized-price--button');
        this.itemizedPriceChevron = this.OS_MODAL.querySelector('.itemized-price--chevron');
        this.itemizedPriceButtonContainer.addEventListener('click', this._toggleItemized);
        this._addDealValues(vehicleData, selectedOption, OS_DATA);
    }

    _toggleItemized() {
        if (this.finishedToggle === true) {
            this.finishedToggle = false;
            if (this._isItemizedOpen(this.itemizedPriceContainer)) {
                this.emitter.emit('itemized-price-toggled', false);
                this.primaryCta.style.display = 'block';
                this.itemizedPriceButton.innerText = 'View itemized price';
                this.itemizedPriceChevron.style.transform = 'rotate(0deg)';
                this.itemizedPriceContainer.classList.remove('itemized-active');
            } else {
                this.emitter.emit('itemized-price-toggled', true);
                this.primaryCta.style.display = 'none';
                this.itemizedPriceContainer.classList.add('itemized-active');
                this.itemizedPriceButton.innerText = 'Hide itemized price';
                this.itemizedPriceChevron.style.transform = 'rotate(180deg)';
                this.itemizedPriceContainer.scrollTop = 0;
                assignPageNameAndFire("onlineShopper/paymentSummary");
            }
            this.finishedToggle = true;
        }
    }

    _isItemizedOpen(container) {
        if (container.classList.contains('itemized-active')) {
            return true;
        } else {
            return false;
        }
    }

    /* istanbul ignore next */
    _addDealValues(vehicleData, selectedOption, OS_DATA) {
        const dealCookie = 'OnlineShopperTradeIn';
        const existingDeal = Cookies.getJSON(dealCookie);
        const msrpAmount = vehicleData.msrp;
        const priceAmount = vehicleData.price;
        vehicleData = vehicleData.payments;

        let dealerDiscountAmount = 0;
        let downPaymentAmount = 0;
        let cashDueAtSigningAmount = 0;
        let totalPurchasePriceAmount = 0;
        let tradeInValueAmount = 0;
        const selectedOffer = vehicleData[selectedOption].selected_offer;
        const salesTaxAmount = this._getTotalAmount(vehicleData[selectedOption].offers[selectedOffer].taxes, vehicleData[selectedOption].term);
        const regFeesAmount = this._getTotalAmount(vehicleData[selectedOption].offers[selectedOffer].fees, vehicleData[selectedOption].term);
        const rebatesAmount = this._getTotalAmount(vehicleData[selectedOption].offers[selectedOffer].rebates, vehicleData[selectedOption].term);
        tradeInValueAmount = existingDeal && existingDeal.customer_estimate ? `- $${formatNumbers(existingDeal.customer_estimate, 'money')}` : '--';

        dealerDiscountAmount = msrpAmount - priceAmount;
        totalPurchasePriceAmount = priceAmount + salesTaxAmount + regFeesAmount;

        this._updateInnerText(this.msrpParagraphText, '$', 'money', msrpAmount, true);
        this._updateInnerText(this.dealerDiscountParagraphText, '- $', 'money', dealerDiscountAmount, true);
        if (this.dealerPriceLabel) { this.dealerPriceLabel.innerText = `${OS_DATA.dealerName} price`; }
        this._updateInnerText(this.dealerPriceHeader, '$', 'money', priceAmount, true);
        this._updateInnerText(this.salesTaxParagraphText, '+ $', 'money', salesTaxAmount, true);
        this._updateInnerText(this.regFeesParagraphText, '+ $', 'money', regFeesAmount, true);
        this._updateInnerText(this.purchasePriceHeader, '$', 'money', totalPurchasePriceAmount, true);
        this._updateInnerText(this.tradeInValueParagraphText, '$', 'money', tradeInValueAmount, false);

        if (!vehicleData[selectedOption].offers[selectedOffer].rebates[0] && this.rebates) {
            this.rebates.classList.add('hidden');
        } else {
            this.rebates.classList.remove('hidden');
            this._updateInnerText(this.rebatesParagraphText, '- $', 'money', rebatesAmount, true);
        }

        if (selectedOption === 'loan') {
            downPaymentAmount = vehicleData[selectedOption].down_payment > 0 ? `- $${formatNumbers(vehicleData[selectedOption].down_payment, 'money')}` : '--';
            this._updateInnerText(this.downPaymentParagraphText, '', 'money', downPaymentAmount, false);
            this.amountFinanced.innerHTML = this._getCapCostHTML('loan');
            this.cashDueAtSigning.classList.add('hidden');
            this.downPayment.classList.remove('hidden');
            this.totalPurchasePrice.classList.remove('hidden');
        } else if (selectedOption === 'lease') {
            this.totalPurchasePrice.classList.add('hidden');
            this.amountFinanced.innerHTML = this._getCapCostHTML('lease');
            downPaymentAmount = vehicleData[selectedOption].down_payment > 0 ? `- $${formatNumbers(vehicleData[selectedOption].down_payment, 'money')}` : '--';
            cashDueAtSigningAmount = vehicleData[selectedOption].down_payment >= 0 ? `$${formatNumbers((vehicleData[selectedOption].down_payment + vehicleData[selectedOption].offers[selectedOffer].payment), 'money')}` : '--';
            this._updateInnerText(this.downPaymentParagraphText, '', 'money', downPaymentAmount, false);
            this._updateInnerText(this.cashDueAtSigningParagraphText, '', 'money', cashDueAtSigningAmount, false);
            this.cashDueAtSigning.classList.remove('hidden');
            this.downPayment.classList.remove('hidden');
        } else {
            this.totalPurchasePrice.classList.remove('hidden');
            this.cashDueAtSigning.classList.add('hidden');
            this.amountFinanced.innerHTML = this._getCapCostHTML('cash');
            this.downPayment.classList.add('hidden');
        }
        this.amountFinancedParagraphText = this.amountFinanced.querySelector('p.amount-financed-paragraph-text');
        this._updateInnerText(this.amountFinancedParagraphText, '$', 'money', vehicleData[selectedOption].offers[0].amount_financed, true);
    }

    _updateInnerText(element, prefix, formatType, amount, canDisplayZero) {
        if (element && canDisplayZero) {
            element.innerText = `${prefix}${formatNumbers(amount, formatType)}`;
        } else {
            element.innerText = amount;
        }
    }

    _getTotalAmount(array, months) {
        let amount = 0;
        array.map((el) => {
            if (el.collected === 'monthly') {
                amount += (el.value * months);
            } else {
                amount += el.value;
            }
        });
        return amount;
    }

    _getCapCostHTML(paymentType){
        if (paymentType === 'loan'){
            return `<span class="itemized-titles amount-financed">Total amount financed (owed)</span>
                    <p class='amount-financed-paragraph-text'></p>`;
        } else if (paymentType === 'lease'){
            return `
                <div class="itemized__tooltip--container">
                    <input class="itemized-check" id="itemized-check1" value="itemized-check1" name="itemized-check1" type="checkbox"/>
                    <div class="tooltip">
                        <p>The term, capitalized cost, or “cap cost“, refers to the amount that is being financed with a lease. The lower the capitalized cost, the lower the monthly lease payment</p>
                        <label class="itemized_check__label" for="itemized-check1">
                            <span>
                                <svg width="20" height="20" class="icon-close"><use xlink:href="#icon-close"></use></svg>
                            </span>
                        </label>
                    </div>
                    <span class="itemized-titles amount-financed">Total cap cost
                        <label class="itemized_check__label" for="itemized-check1">
                            <svg class="itemized__tooltip" height="18" width="18" viewbox="0 0 18 18">
                                    <use xlink:href="/cldstatic/vdp/%%FINGERPRINT%%/spritemap.svg#info-line" />
                            </svg>
                        </label>
                    </span>
                </div>
                <p class='amount-financed-paragraph-text'></p>`;
        } else {
            return `<span class="itemized-titles amount-financed">Total cash amount (owed)</span>
                    <p class='amount-financed-paragraph-text'></p>`;
        }
    }
}

export default ItemizedPriceComponent;
